<div class="app-grid" [class.sidebar-collapsed]="isCollapsed()">
  <a
    class="app-brand"
    [routerLink]="dashboardRoute()"
    [attr.aria-label]="'layout.topbar.brandaria' | t"
  >
    <app-brand-logo [compact]="isCollapsed()" />
  </a>

  <div class="app-topbar-wrap">
    <button
      type="button"
      class="app-collapse-btn"
      [class.is-collapsed]="isCollapsed()"
      (click)="toggleSidebar()"
      [attr.aria-label]="(isCollapsed() ? 'layout.mainLayout.expandSidebar' : 'layout.mainLayout.collapseSidebar') | t"
      [attr.title]="(isCollapsed() ? 'layout.mainLayout.expandSidebar' : 'layout.mainLayout.collapseSidebar') | t"
    >
      <lucide-icon name="chevron-left" [size]="16" aria-hidden="true"></lucide-icon>
    </button>
    <app-topbar class="app-topbar-area"></app-topbar>
  </div>

  <app-sidebar class="app-sidebar-area"></app-sidebar>

  <main class="app-content">
    <app-trial-banner />
    <app-billing-status-banner />
    <app-onboarding-tour></app-onboarding-tour>
    <app-checklist-completion-modal></app-checklist-completion-modal>
    <app-company-vertical-modal
      [visible]="verticalModalVisible()"
      [activeCompanyId]="verticalModalActiveCompanyId()"
      (closed)="onVerticalModalClosed()"
      (verticalSelected)="onVerticalSelected($event)"
    />

    <div class="app-content__scroll">
      <div class="app-content__body">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
